import { type FC } from 'react'
import { FormattedMessage, type IntlShape, useIntl } from 'react-intl'

import { RxByPrincipleReasonSet } from '@redteclab/api/clients/bully'
import { BrandIconPillBlister } from '@redteclab/brand-icons'

import { BrandIcon } from 'base-ui'

const getHeaderReasonSet = (
  reasonSet: RxByPrincipleReasonSet,
  intl: IntlShape,
): string => {
  const headerReasonSet = {
    [RxByPrincipleReasonSet.Dextromethorfan]: (): string =>
      intl.formatMessage({
        id: 'rxByPrincipleModal.headerText.reasonSet.dextromethorfan',
      }),
    [RxByPrincipleReasonSet.Paracetamol]: (): string =>
      intl.formatMessage({
        id: 'rxByPrincipleModal.headerText.reasonSet.paracetamol',
      }),
    [RxByPrincipleReasonSet.ParacetamolIbuprofen]: (): string =>
      intl.formatMessage({
        id: 'rxByPrincipleModal.headerText.reasonSet.paracetamolIbuprofen',
      }),
    [RxByPrincipleReasonSet.ParacetamolPseudoEfedrine]: (): string =>
      intl.formatMessage({
        id: 'rxByPrincipleModal.headerText.reasonSet.paracetamolPseudoEfedrine',
      }),
    [RxByPrincipleReasonSet.PseudoEfedrine]: (): string =>
      intl.formatMessage({
        id: 'rxByPrincipleModal.headerText.reasonSet.pseudoEfedrine',
      }),
  }

  return headerReasonSet[reasonSet]()
}

type ProductPageRxByPrincipleHeaderProps = {
  reasonSet: RxByPrincipleReasonSet
}

export const ProductPageRxByPrincipleHeader: FC<
  ProductPageRxByPrincipleHeaderProps
> = ({ reasonSet }) => {
  const intl = useIntl()

  return (
    <header className="flex gap-4">
      <BrandIcon
        className="shrink-0"
        color="secondary"
        icon={BrandIconPillBlister}
        size="m"
      />
      <p className="text-m font-medium tablet:text-l">
        <FormattedMessage
          id="rxByPrincipleModal.headerText"
          values={{ reasonSet: getHeaderReasonSet(reasonSet, intl) }}
        />
      </p>
    </header>
  )
}
